import {PropConfig} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/PropConfig';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {ComponentConfig} from '@mintdata/mint-kit/api/decorators/Component';
import {EventMap} from '@mintdata/mint-kit/api/events/EventMap';
import {EventUtils} from '@mintdata/mint-kit/api/events/EventUtils';
import {ContainerPropertyConfig} from '@mintdata/mint-kit/api/properties/ContainerPropertyConfig';
import {PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {PropertyUtils} from '@mintdata/mint-kit/api/properties/PropertyUtils';
import * as React from 'react';

export class ResolvedVisualComponent
{
    public readonly componentConfig:ComponentConfig<any, any>;
    public readonly componentCtor:React.ComponentClass<any>;
    public readonly propertiesConfigs:Map<PropName, PropConfig<any>> = new Map<PropName, PropConfig<any>>();
    public readonly layoutPropertiesConfigs:Map<PropName, PropConfig<any>> = new Map<PropName, PropConfig<any>>();
    public readonly containerPropertyConfig:ContainerPropertyConfig;
    public readonly eventMap:EventMap;

    public constructor(componentCtor:React.ComponentClass<any>)
    {
        this.componentCtor = componentCtor;
        this.componentConfig = PropertyUtils.getComponentConfig(this.componentCtor);

        const defaultPropsValues:any = this.componentConfig.props
            ? new this.componentConfig.props()
            : null;

        PropConfig.fillPropsConfigs(
            this.propertiesConfigs,
            defaultPropsValues
        );

        SystemPropsConfigs.fillLayoutPropsConfigs(this.layoutPropertiesConfigs);

        this.containerPropertyConfig = PropertyUtils.getContainerPropertyConfig(
            defaultPropsValues
        );

        this.eventMap = EventUtils.getEventMap(this.componentConfig.props.prototype);
    }
}
